export default __webpack_public_path__ + "static/1.2-ab125ee0cc9d7d6d84e8bd821bf688f9.webp";